import React, { HTMLAttributes } from 'react'
import { BeatLoader } from 'react-spinners'

import styles from './styles.module.scss'
import classNames from 'classnames'
import Link from 'next/link'

export type EditorialNavBarItem = {
  id?: number
  name: string
  slug?: string
  path?: string
}

interface EditorialNavbarProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onSelect'> {
  name?: string
  showBorder?: boolean
  loading?: boolean
  items: EditorialNavBarItem[]
  onSelect?: (editorial: EditorialNavBarItem) => void
}

export const EditorialNavBar = ({
  name,
  items,
  showBorder,
  loading,
  className,
  onSelect,
  ...rest
}: EditorialNavbarProps): JSX.Element => {
  return (
    <div className={className} {...rest}>
      <div
        className={classNames(styles.container, {
          [styles.border]: !showBorder
        })}
      >
        {items.map(item =>
          onSelect ? (
            <button
              key={item.name}
              type="button"
              disabled={name === item.name}
              onClick={() => onSelect && onSelect(item)}
              className={classNames(styles.item, {
                [styles.active]: name === item.name,
                [styles.border]: showBorder,
                [styles.loading]: loading && name === item.name
              })}
            >
              {loading && name === item.name ? (
                <BeatLoader size="15px" color="#ff9c00" />
              ) : (
                <>{showBorder ? item.name : item.name.toUpperCase()}</>
              )}
            </button>
          ) : (
            <Link
              key={item.name}
              href={item.path}
              className={classNames(styles.item, {
                [styles.active]: name === item.name,
                [styles.border]: showBorder
              })}
            >
              <h2>{item.name}</h2>
            </Link>
          )
        )}
      </div>
    </div>
  )
}
